module.exports = __webpack_public_path__ + "static/media/powered-by-mangopay.ef72e0d4.png";